// must support both server and client components (is usd by CustomSVG.client and CustomSVG.server)

import { ElementType } from "react";

import { customSanitize } from "@/utils/customSanitize";

export type CustomSVGProps = React.HTMLAttributes<HTMLElement> & {
  wrapper?: ElementType;
  width?: number | string;
  height?: number | string;
  className?: string;
  "aria-hidden"?: boolean | "true" | "false";
  role?: string;
  alt?: string;
  "aria-label"?: string;
  fallback?: React.ReactNode;
} & ({ src: string } | { iconKey: string });

export default function CustomSVG(
  props: CustomSVGProps & { svgContent: string },
) {
  const {
    wrapper: Wrapper = "span",
    width,
    height,
    className = "",
    "aria-hidden": ariaHidden,
    role,
    alt,
    "aria-label": ariaLabel,
    svgContent,
    ...rest
  } = props;

  const attrs: Record<string, string | undefined> = {
    width: width?.toString(),
    height: height?.toString(),
    "aria-hidden": ariaHidden?.toString(),
    role,
    alt,
    "aria-label": ariaLabel,
  };

  const updatedSVG = svgContent.replace(
    "<svg",
    `<svg ${Object.entries(attrs)
      .filter(([_, v]) => v !== undefined)
      .map(([k, v]) => `${k}="${v}"`)
      .join(" ")}`,
  );

  const {
    iconKey: _,
    src: __,
    ...safeRest
  } = rest as {
    iconKey?: string;
    src?: string;
  };

  return (
    <Wrapper
      className={className}
      dangerouslySetInnerHTML={{ __html: customSanitize(updatedSVG) }}
      {...safeRest}
    />
  );
}
